import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { Store } from '@ngrx/store';
import { combineLatest, filter, map, tap } from 'rxjs';
import { selectSelectedCompany, selectUserProfile } from '../../auth/store/auth.selectors';
import { Vehicle } from './models/vehicle.class';
import { Fleet } from './models/vehicle.models';
import { getFleetList, getVehicleBrands, getVehicleList } from './store/vehicle.actions';
import { selectFleets, selectVehicleBrands, selectVehicles } from './store/vehicle.selectors';

/**
 * Resolves current Account's Vehicle and Fleet lists.
 * Calls backend if lists were not pulled previously
 */
export const resolveVehicles: ResolveFn<{ vehicles: Vehicle[]; fleets: Fleet[] }> = () => {
  const store = inject(Store);

  return combineLatest([
    store.select(selectVehicles),
    store.select(selectFleets),
    store.select(selectVehicleBrands),
    store.select(selectSelectedCompany),
    store.select(selectUserProfile),
  ]).pipe(
    // make sure Account and UserProfile are resolved prior or alongside this resolver
    filter(([, , , account, user]) => !!account && !!user),
    tap(([vehicles, fleets, brands]) => {
      if (vehicles.untouched) store.dispatch(getVehicleList());
      if (fleets.untouched) store.dispatch(getFleetList());
      if (brands.untouched) store.dispatch(getVehicleBrands());
    }),
    filter(([vehicles, fleets]) => !vehicles.untouched && !fleets.untouched),
    map(([vehicles, fleets]) => ({
      vehicles: vehicles.value ?? [],
      fleets: fleets.value ?? [],
    }))
  );
};
